import { useSelector, useDispatch } from 'react-redux';
import { getInsuredItems, getInsuredItem } from '../actions/insuredItems';
import { dateToString, toTitleCase } from '../utils/functions';
import { listSelector } from '../selectors';
import { insuredItemsIndexName, agentType } from '../utils/variables';
// import { getRenewalPolicy } from '../actions/renewals';
// import { loadInsuredItemsCount } from '../utils/variables';

const useInsuredItemData = ({ infiniteScroll = false, policyId } = {}) => {
  // const dispatch = useDispatch();
  const insurances = useSelector(state => state.insurance.insurances) || [];
  // // console.log('insurance: ', insurance);
  const policy = insurances.find(x => x.id === policyId);
  // // console.log('policy: ', policy);
  const isPending = useSelector(state => state?.insuredItems?.isPending);
  // // console.log('Insurance', insurance);

  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const selectedClient = useSelector(state => state?.auth?.selectedClient);

  const customerId =
    auth.usertype === agentType ? selectedClient?.clientNumber : auth?.user?.customer?.id;
  const agentId = auth?.user?.agent?.id;
  const usertype = auth?.usertype;
  const defaultOptions = useSelector(state =>
    listSelector.listOptions({ state, name: insuredItemsIndexName, infiniteScroll }),
  );
  const allRows = useSelector(state => state.insuredItems.allRows);

  return ({ nextStartIndex, nextItemCount, nextScrollCount, actionIndex }) => {
    // const limit = count; // stopIndex - startIndex;
    // const offset = startIndex;
    // // console.log('Policy', policy);
    const body = {
      id: customerId,
      masterId: customerId,
      policyId,
      limit: defaultOptions?.itemCount,
      offset: defaultOptions?.startIndex,
      fromDate: dateToString(defaultOptions?.startDate),
      toDate: dateToString(defaultOptions?.endDate),
      lob: toTitleCase(defaultOptions?.lob.toString()), // toTitleCase(defaultOptions?.lob),
      nextItemCount,
      nextScrollCount,
      nextStartIndex,
      agentId,
      usertype,
      // policy,
    };

    // cellMeasurerCache.clearAll();
    // listRef.current.recomputeRowHeights();
    // listRef.current.forceUpdate();
    if (allRows && actionIndex > 0 && infiniteScroll) {
      return dispatch(getInsuredItems.getNextInsuredItemsAction(body, policy));
    }
    if (!isPending && actionIndex === 0) {
      // return dispatch(getInsuredItems.getInsuredItemsAction(body));
      return dispatch(getInsuredItem.getInsuredItemAction(body, policy));
    }
    return () => {};
  };
};
export default useInsuredItemData;

/*

  const insuredItems = [];
  insurance.forEach(policy => {
    // // console.log('Policy', policy);
    const {
      title,
      status,
      lob,
      id,
      inceptionDate,
      expiryDate,
      insuredName,
      currency,
      modalPremium,
      icon,
      producer,
    } = policy;
    const items = policy?.insuredItems || [];
    // // console.log('items', items);
    if (Array.isArray(items)) {
      items.forEach(x => {
        // // console.log('x', x);
        insuredItems.push({
          ...x,
          title,
          status,
          lob,
          policyId: id,
          inceptionDate,
          expiryDate,
          insuredName,
          currency,
          modalPremium,
          icon,
          producer,
        });
      });
    } else if (typeof items === 'object') {
      // // console.log('I am here....');
      insuredItems.push({
        ...items,
        title,
        status,
        lob,
        policyId: id,
        inceptionDate,
        expiryDate,
        insuredName,
        currency,
        modalPremium,
        icon,
        producer,
      });
    }
  });
  // // console.log('Nested Insured Items', insuredItems);
  */
